export default __webpack_public_path__ + "static/media/Rapidstore-poster.280d0681.png";